import React from 'react'
import styles from './ActionItem.module.scss'

interface ActionItemProps {
  text: string
  onClick(): void
}

export const ActionItem = ({ text, onClick }: ActionItemProps) => (
  <li className={styles.actionItem} onClick={onClick}>
    {text}
  </li>
)
